<template>
  <div>
    <BaseLoader v-if="loadingInit" />
    <div
      v-else
      class="d-flex flex-column"
    >
      <div class="texte texte-gris-fonce">
        Rendement (qx/ha)
      </div>
      <BaseInputNumberIncrement
        :object-value="rendement"
        :min="rendement.min"
        :max="rendement.max"
        :is-disabled="!hasDroitEcritureSimulateur"
        @update="onRendementUpdate"
      />
      <div class="texte texte-gris-fonce">
        Charges intrants (€/ha)
      </div>
      <div
        v-if="$vuetify.breakpoint.mobile"
        class="mt-1 d-flex flex-column"
      >
        <div
          class="d-flex"
        >
          <BaseInputNumberIncrement
            libelle="Semences"
            class="pr-2"
            :object-value="chargesSemences"
            :min="chargesSemences.min"
            :max="chargesSemences.max"
            :is-disabled="!hasDroitEcritureSimulateur"
            @update="onChargesSemencesUpdate"
          />
          <BaseInputNumberIncrement
            libelle="Engrais"
            class="pr-1"
            :object-value="chargesEngrais"
            :min="chargesEngrais.min"
            :max="chargesEngrais.max"
            :is-disabled="!hasDroitEcritureSimulateur"
            @update="onChargesEngraisUpdate"
          />
        </div>
        <BaseInputNumberIncrement
          libelle="Traitements"
          :object-value="chargesPhyto"
          :min="chargesPhyto.min"
          :max="chargesPhyto.max"
          :is-disabled="!hasDroitEcritureSimulateur"
          @update="onChargesPhytoUpdate"
        />
      </div>
      <div
        v-else
        class="mt-1 d-flex justify-space-around"
      >
        <BaseInputNumberIncrement
          libelle="Semences"
          :object-value="chargesSemences"
          :min="chargesSemences.min"
          :max="chargesSemences.max"
          :is-disabled="!hasDroitEcritureSimulateur"
          class="pr-2"
          @update="onChargesSemencesUpdate"
        />
        <BaseInputNumberIncrement
          libelle="Engrais"
          class="pr-2"
          :object-value="chargesEngrais"
          :min="chargesEngrais.min"
          :max="chargesEngrais.max"
          :is-disabled="!hasDroitEcritureSimulateur"
          @update="onChargesEngraisUpdate"
        />
        <BaseInputNumberIncrement
          libelle="Traitements"
          :object-value="chargesPhyto"
          :min="chargesPhyto.min"
          :max="chargesPhyto.max"
          :is-disabled="!hasDroitEcritureSimulateur"
          @update="onChargesPhytoUpdate"
        />
      </div>
      <div
        class="d-flex eqWrap"
      >
        <div class="d-flex pr-1 flex-column equalHW">
          <div class="texte texte-gris-fonce">
            Charges fixes (€/ha)
          </div>
          <BaseInputNumberIncrement
            :object-value="chargesFixes"
            :class="$vuetify.breakpoint.mobile ? '' : 'pr-4'"
            :min="chargesFixes.min"
            :max="chargesFixes.max"
            :is-disabled="!hasDroitEcritureSimulateur"
            @update="onChargesFixesUpdate"
          />
        </div>
        <div class="d-flex pl-1 flex-column equalHW">
          <div class="texte texte-gris-fonce">
            Rémunération (€/ha)
          </div>
          <BaseInputNumberIncrement
            v-if="!loadingConfiguration"
            :object-value="remuneration"
            :min="remuneration.min"
            :max="remuneration.max"
            :is-disabled="!hasDroitEcritureSimulateur"
            @update="onRemunerationUpdate"
          />
        </div>
      </div>
      <BaseMessage
        v-if="erreurBorne"
        type="warning"
        text
        color="warning"
        class="ma-2"
        :message="erreurBorne"
      />
      <div class="d-flex mb-1">
        <div class="align-self-center equalHW titre-h4 secondary--text">
          Prix d'équilibre théorique
        </div>
        <div class="align-self-center equalHW flex-shrink-1 chiffre secondary--text align-end">
          <span v-if="prixEquilibreTheoriqueEnEuroParTonne != null">{{ prixEquilibreTheoriqueEnEuroParTonne | roundNumber(0) }} €/t</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {clone} from '@/utils/clone'
import BaseInputNumberIncrement from '@/components/form/base-input-number-increment.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'

export default {
  name: 'SimulateurPrixEquilibre',
  components: { BaseInputNumberIncrement, BaseLoader, BaseMessage },
  props: {
    numtiersSelected: {
      type: String,
      default: null
    },
    isUtilisateurAgrial: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loadingConfiguration: true,
      loadingInitReperesEconomiques: true,
      codeGraine: null,
      rendement: {},
      erreurRendement: null,
      chargesSemences: {},
      erreurChargesSemences: null,
      chargesEngrais: {},
      erreurChargesEngrais: null,
      chargesPhyto: {},
      erreurChargesPhyto: null,
      chargesFixes: {},
      erreurChargesFixes: null,
      remuneration: {},
      erreurRemuneration: null,
      VALEUR_MAX_DEFAUT: 10000
    }
  },
  computed: {
    ...mapGetters({
      adherent:'adherent/adherent',
      configurationGraineActive: 'reperesEconomiques/configurationGraineActive',
      reperesEconomiques: 'reperesEconomiques/reperesEconomiquesByGraine',
      codeGraineActive: 'application/codeGraineActive'
    }),

    erreurBorne () {
      let result = null
      if (this.erreurRendement) {
        result = this.erreurRendement
      } else if (this.erreurChargesSemences) {
        result = this.erreurChargesSemences
      } else if (this.erreurChargesEngrais) {
        result = this.erreurChargesEngrais
      } else if (this.erreurChargesPhyto) {
        result = this.erreurChargesPhyto
      } else if (this.erreurChargesFixes) {
        result = this.erreurChargesFixes
      } else if (this.erreurRemuneration) {
        result = this.erreurRemuneration
      }
      return result
    },

    prixEquilibreTheoriqueEnEuroParTonne () {
      const termes = [
        this.chargesSemences.valeur,
        this.chargesEngrais.valeur,
        this.chargesPhyto.valeur,
        this.chargesFixes.valeur,
        this.remuneration.valeur
      ]
      const rendementEnQuintalParHectare = this.rendement.valeur

      if (termes.some(terme => terme == null) || rendementEnQuintalParHectare == null || Number(rendementEnQuintalParHectare) === 0) {
        return null
      }

      const chargesEnEuroParHectare = termes.reduce((total, terme) => total + Number(terme), 0)

      return chargesEnEuroParHectare / (Number(rendementEnQuintalParHectare) * 0.1)
    },

    loadingInit () {
      return this.loadingConfiguration || this.loadingInitReperesEconomiques
    },
    hasDroitEcritureSimulateur () {
      return this.$roles.hasDroitEcritureParametresCompte() || (this.isUtilisateurAgrial && !this.adherent.full)
    },
  },

  watch: {
    codeGraineActive: {
      handler () {
        this.codeGraine = this.codeGraineActive && this.adherent.numtiers!= null ? this.codeGraineActive : null
        this.fetchGraineConfiguration()
      },
      immediate: true
    }
  },
  
  methods: {
    ...mapActions({
      getConfigurationParGraine: 'reperesEconomiques/getConfigurationParGraine',
      getReperesEconomiqueByGraine: 'reperesEconomiques/getReperesEconomiqueByGraine',
      saveReperesEconomiques: 'reperesEconomiques/saveReperesEconomiques'
    }),

    fetchGraineConfiguration () {
      this.loadingConfiguration = true
      this.getConfigurationParGraine(this.codeGraine)
        .then(() => {
          this.rendement = {
            valeur: null,
            min: this.configurationGraineActive.rendement.minimum ? this.configurationGraineActive.rendement.minimum : 0,
            max: this.configurationGraineActive.rendement.maximum ? this.configurationGraineActive.rendement.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.chargesSemences = {
            valeur: null,
            min: this.configurationGraineActive.chargesSemences.minimum ? this.configurationGraineActive.chargesSemences.minimum : 0,
            max: this.configurationGraineActive.chargesSemences.maximum ? this.configurationGraineActive.chargesSemences.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.chargesEngrais = {
            valeur: null,
            min: this.configurationGraineActive.chargesEngrais.minimum ? this.configurationGraineActive.chargesEngrais.minimum : 0,
            max: this.configurationGraineActive.chargesEngrais.maximum ? this.configurationGraineActive.chargesEngrais.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.chargesPhyto = {
            valeur: null,
            min: this.configurationGraineActive.chargesPhyto.minimum ? this.configurationGraineActive.chargesPhyto.minimum : 0,
            max: this.configurationGraineActive.chargesPhyto.maximum ? this.configurationGraineActive.chargesPhyto.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.chargesFixes = {
            valeur: null,
            min: this.configurationGraineActive.chargesFixes.minimum ? this.configurationGraineActive.chargesFixes.minimum : 0,
            max: this.configurationGraineActive.chargesFixes.maximum ? this.configurationGraineActive.chargesFixes.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.remuneration = {
            valeur: null,
            min: this.configurationGraineActive.remuneration.minimum ? this.configurationGraineActive.remuneration.minimum : 0,
            max: this.configurationGraineActive.remuneration.maximum ? this.configurationGraineActive.remuneration.maximum : this.VALEUR_MAX_DEFAUT
          }
          this.fetchReperesEconomiquesGraineActive()
        })
        .finally(() => {
          this.loadingConfiguration = false
        })
    },

    fetchReperesEconomiquesGraineActive () {
      this.loadingInitReperesEconomiques = true
      this.getReperesEconomiqueByGraine(this.codeGraine)
        .then(() => {
          this.updateInputsAvecDonneesServeur()
        })
        .finally(() => {
          this.loadingInitReperesEconomiques = false
        })
    },

    saveReperes () {
      const reperesEconomiquesUpdated = clone(this.reperesEconomiques)
      reperesEconomiquesUpdated.rendementEnQuintalParHectare = this.rendement.valeur
      reperesEconomiquesUpdated.chargesSemencesEnEuroParHectare = this.chargesSemences.valeur
      reperesEconomiquesUpdated.chargesEngraisEnEuroParHectare = this.chargesEngrais.valeur
      reperesEconomiquesUpdated.chargesPhytoEnEuroParHectare = this.chargesPhyto.valeur
      reperesEconomiquesUpdated.chargesFixesEnEuroParHectare = this.chargesFixes.valeur
      reperesEconomiquesUpdated.remunerationEnEuroParHectare = this.remuneration.valeur
      this.saveReperesEconomiques(reperesEconomiquesUpdated)
    },

    updateInputsAvecDonneesServeur () {
      this.rendement.valeur = this.reperesEconomiques.rendementEnQuintalParHectare
      this.chargesSemences.valeur = this.reperesEconomiques.chargesSemencesEnEuroParHectare
      this.chargesEngrais.valeur = this.reperesEconomiques.chargesEngraisEnEuroParHectare
      this.chargesPhyto.valeur = this.reperesEconomiques.chargesPhytoEnEuroParHectare
      this.chargesFixes.valeur = this.reperesEconomiques.chargesFixesEnEuroParHectare
      this.remuneration.valeur = this.reperesEconomiques.remunerationEnEuroParHectare
    },

    onRendementUpdate (newValue) {
      this.erreurRendement = null
      this.$gtag.event('repere_eco', {
        action: 'rendement'
      })
      this.$set(this.rendement, 'valeur', newValue)
      if (newValue >= this.rendement.min && newValue <= this.rendement.max) {
        this.saveReperes()
      } else {
        this.erreurRendement = 'La valeur du rendement est invalide'
      }
    },

    onChargesSemencesUpdate (newValue) {
      this.erreurChargesSemences = null
      this.$gtag.event('repere_eco', {
        action: 'charges semences'
      })
      this.$set(this.chargesSemences, 'valeur', newValue)
      if (newValue >= this.chargesSemences.min && newValue <= this.chargesSemences.max) {
        this.saveReperes()
      } else {
        this.erreurChargesSemences = 'La valeur des charges semences est invalide'
      }
    },

    onChargesEngraisUpdate (newValue) {
      this.erreurChargesEngrais = null
      this.$gtag.event('repere_eco', {
        action: 'charges engrais'
      })
      this.$set(this.chargesEngrais, 'valeur', newValue)
      if (newValue >= this.chargesEngrais.min && newValue <= this.chargesEngrais.max) {
        this.saveReperes()
      } else {
        this.erreurChargesEngrais = 'La valeur des charges engrais est invalide'
      }
    },

    onChargesPhytoUpdate (newValue) {
      this.erreurChargesPhyto = null
      this.$gtag.event('repere_eco', {
        action: 'charges phyto'
      })
      this.$set(this.chargesPhyto, 'valeur', newValue)
      if (newValue >= this.chargesPhyto.min && newValue <= this.chargesPhyto.max) {
        this.saveReperes()
      } else {
        this.erreurChargesPhyto = 'La valeur des charges traitements est invalide'
      }
    },

    onChargesFixesUpdate (newValue) {
      this.erreurChargesFixes = null
      this.$gtag.event('repere_eco', {
        action: 'charges fixes'
      })
      this.$set(this.chargesFixes, 'valeur', newValue)
      if (newValue >= this.chargesFixes.min && newValue <= this.chargesFixes.max) {
        this.saveReperes()
      } else {
        this.erreurChargesFixes = 'La valeur des charges fixes est invalide'
      }
    },

    onRemunerationUpdate (newValue) {
      this.erreurRemuneration = null
      this.$gtag.event('repere_eco', {
        action: 'rémunération'
      })
      this.$set(this.remuneration, 'valeur', newValue)
      if (newValue >= this.remuneration.min && newValue <= this.remuneration.max) {
        this.saveReperes()
      } else {
        this.erreurRemuneration = 'La valeur de la rémunération est invalide'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.eqWrap {
	display: flex;
}

.equalHW {
	flex: 1;
}

.align-end {
  text-align: end;
}

</style>